import * as React from 'react';

import { clsx } from 'clsx';

import * as styles from './PaginationItem.css';

interface IPaginationItemProps {
  isCurrentPage?: boolean;
  children: React.ReactNode;
}

export const PaginationItem: React.FC<IPaginationItemProps> = ({ isCurrentPage, children }) => {
  return (
    <div
      data-testid={isCurrentPage ? 'pagination-item-current' : 'pagination-item'}
      className={clsx(styles['pagination-item'], isCurrentPage && styles['pagination-item--current'])}
    >
      {children}
    </div>
  );
};
